// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"_1unN","breadcrumb":"_2JAO","v2":"Oe1b","v4":"_308U","v1":"_19zs","v5":"_1AQO","v3":"_2kSR"};